var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 10.7799L3.68664 8.46655C3.42664 8.20655 3.00664 8.20655 2.74664 8.46655C2.48664 8.72655 2.48664 9.14655 2.74664 9.40655L5.5333 12.1932C5.7933 12.4532 6.2133 12.4532 6.4733 12.1932L13.5266 5.13988C13.7866 4.87988 13.7866 4.45988 13.5266 4.19988C13.2666 3.93988 12.8466 3.93988 12.5866 4.19988L5.99997 10.7799Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.521c69549ad022a0c4ad84c784c371b6.svg";
export { ForwardRef as ReactComponent };